/**
 * RTK Query slice для DaData API (прямой запрос с фронтенда)
 * Используется только для онбординга партнера (первый вход)
 */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { DADATA_CONFIG } from "../lib/dadataConfig";
import type {
  DaDataSuggestRequest,
  DaDataSuggestResponse,
} from "../types/DaDataTypes";

/**
 * Отдельный API slice для DaData (внешний API)
 */
export const DaDataApiSlice = createApi({
  reducerPath: "daDataApi",
  baseQuery: fetchBaseQuery({
    baseUrl: DADATA_CONFIG.baseUrl,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");
      headers.set("Authorization", `Token ${DADATA_CONFIG.apiKey}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    /**
     * Подсказки адресов
     */
    suggestAddress: builder.mutation<DaDataSuggestResponse, DaDataSuggestRequest>(
      {
        query: (body) => ({
          url: "/suggest/address",
          method: "POST",
          body,
        }),
      }
    ),
  }),
});

/**
 * Хук для использования подсказок адресов
 */
export const { useSuggestAddressMutation } = DaDataApiSlice;
